module.exports = __webpack_public_path__ + "img/528.29f3420f.png";